import { useFirebaseAuth } from '@smart-maps/firebase';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';

import { deleteMarker } from '../../redux/actions';

const useStyles = createUseStyles({
  button: {
    borderRadius: 4,
    composes: ['p12', 'text-center', 'mt12', 'is-full-width', 'fs14'],
    transition: 'all 0.3s',
    width: '100%',
  },
});

const DeleteButtonComponent = React.memo(({ id }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { user } = useFirebaseAuth();
  return (
    <button
      className={classnames(classes.button, 'smart-maps-button-danger')}
      type="button"
      onClick={() => dispatch(deleteMarker(id, user))}>
      <span>Supprimer</span>
    </button>
  );
});

DeleteButtonComponent.propTypes = {
  id: PropTypes.string.isRequired,
};

DeleteButtonComponent.displayName = 'DeleteButtonComponent';

export default DeleteButtonComponent;
